import { LandingSectionEyebrow } from '@/components/landing/landing-section-eyebrow'
import type { LandingFeatureBlock } from '@/lib/landing-content'
import { LANDING_SECTION_GRADIENT } from '@/lib/landing-content'

type LandingFeatureBlockSectionProps = {
  block: LandingFeatureBlock
}

export function LandingFeatureBlockSection({ block }: LandingFeatureBlockSectionProps) {
  return (
    <section
      id={block.id}
      className="py-12 md:py-32 scroll-fade-up"
      style={{ backgroundImage: LANDING_SECTION_GRADIENT }}
    >
      <div className="container mx-auto px-4 md:px-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-10 md:mb-16">
            <LandingSectionEyebrow label={block.eyebrow} className="mb-4" />
            <div className="flex flex-col gap-1 max-w-4xl">
              <h2 className="text-3xl md:text-[48px] font-display text-gray-900 leading-[1.2] tracking-[-0.96px]">
                {block.title}
              </h2>
              <p className="text-3xl md:text-[48px] font-display text-gray-400 leading-[1.2] tracking-[-0.96px]">
                {block.titleMuted}
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-start">
            <div className="order-2 md:order-1 flex flex-col gap-6 md:gap-8">
              <p className="text-base font-medium text-gray-500 tracking-[-0.32px] leading-relaxed">
                {block.body}
              </p>
              {block.bullets.map((bullet) => (
                <div key={bullet.title} className="flex flex-col gap-2">
                  <h3 className="text-lg font-medium text-gray-900 tracking-[-0.36px]">
                    {bullet.title}
                  </h3>
                  <p className="text-base font-medium text-gray-500 tracking-[-0.32px]">
                    {bullet.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="order-1 md:order-2 rounded-2xl overflow-hidden aspect-[624/480] relative">
              <img
                src={block.imageSrc}
                alt={block.imageAlt}
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
